import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import session from '../../../../share/session';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../share/util/api/polling';
import { save } from './save';
import { PHASE } from './constants';

/**
 * ログデータ取得
 * @param {object} self this インスタンス
 */
export async function upload(self) {
  try {
    self.isLoading = true;
    self.phase = PHASE.DATA_ACQUISITION;
    const selectedItems = getSelectedItems(self);
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'upload',
        did_list: selectedItems
      },
      // エラー発生のコールバック
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async (result) => { await self.validateErrorResult(result); }
    );

    if (response) {
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          self.requestId = response.data.user_data.request_id;
          self.dataName = response.data.user_data.data_name;
          if (response.data.user_data.upload_results.some(item => item.upload_status === "completed") && !self.isCanceled) {
            self.resultItems = makeResultItems(response.data.user_data.upload_results, self.displayedIndexItems);
            await save(self);
          } else {
            // upload_results内にupload_statusがcompletedの要素がない場合、エラー
            // キャンセルボタンが押下されている場合、プロジェクトデータは保存せずにエラー
            await self.showIndividualError();
          }
          break;
        case REQUEST_STATUS_FAILED:
          await self.showIndividualError();
          break;
      }
    }
  } finally {
    self.isLoading = false;
  }
}

/**
 * did_list作成
 * @param {object} self this インスタンス
 * @returns {object} did_list
 */
function getSelectedItems(self) {
  return self.displayedIndexItems.filter(item => item.isChecked).map(indexInfo => {
    return {
      did: parseInt(indexInfo.did, 16),
      period_start: convertDateString(indexInfo.period_start),
      period_end: convertDateString(indexInfo.period_end)
    };
  });
}

/**
 * 日時を文字列から数値に変換
 * @param {string} dateString "YYYY/MM/DD hh:mm:ss"形式
 * @returns {number} YYYYMMDDhhmmss形式
 */
function convertDateString(dateString) {
  // 日付文字列を分割
  const [datePart, timePart] = dateString.split(' ');
  const [year, month, day] = datePart.split('/');
  const [hours, minutes, seconds] = timePart.split(':');

  // 各部分を結合して新しい文字列を作成
  const formattedString = `${year}${month.padStart(2, '0')}${day.padStart(2, '0')}${hours.padStart(2, '0')}${minutes.padStart(2, '0')}${seconds.padStart(2, '0')}`;

  // 数値に変換して返す
  return Number(formattedString);
}

/**
 * レスポンスボディとIndex表示の情報を統合する
 * @param {object} uploadResults ログデータ取得結果
 * @param {object} displayedIndexItems Index表示画面の表示項目
 * @returns {object} uploadResultsにnumberの情報を付与したもの
 */
function makeResultItems(uploadResults, displayedIndexItems) {
  return uploadResults.map(uploadResult => {
    const readResult = displayedIndexItems.find(read => read.did === uploadResult.id);

    return {
      did: parseInt(uploadResult.id), // idを整数に変換
      number: readResult.number, // 対応するnumberを取得
      timestamp: `${readResult.period_start} ~ ${readResult.period_end}`, // 対応する期間を取得
      upload_status: uploadResult.upload_status // upload_statusを取得
    };
  });
}